module.exports = __webpack_public_path__ + "img/img_16.b3a42d57.jpg";